import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=cc2e2842&"
import script from "./SimpleDialog.vue?vue&type=script&lang=js&"
export * from "./SimpleDialog.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports